export const defaultGeneralPreChatSurveyPaneStyleProps = {
  borderStyle: "solid",
  borderRadius: "inherit",
  borderWidth: "0px",
  backgroundColor: "#FFFFFF",
  borderColor: "#F1F1F1",
  overflowY: "auto",
  height: "inherit",
  width: "inherit"
};